import { ApiError } from '../errors/api-error.js';

export class DeadLetterService {
    constructor(api) { this.api = api; }

    async list(p) { return this._w(() => this.api.list(p), 'Failed to list DLQ'); }
    async metrics() { return this._w(() => this.api.metrics(), 'Failed to load DLQ metrics'); }
    async getById(id) { return this._w(() => this.api.getById(id), 'Failed to load DLQ item'); }
    async retry(id) { return this._w(() => this.api.retry(id), 'Failed to retry', 'Olay yeniden gönderildi'); }
    async abandon(id) { return this._w(() => this.api.abandon(id), 'Failed to abandon', 'Olay iptal edildi'); }
    async retryAll(body) { return this._w(() => this.api.retryAll(body), 'Failed bulk retry', 'Toplu yeniden gönderim tamamlandı'); }
    async abandonAll(body) { return this._w(() => this.api.abandonAll(body), 'Failed bulk abandon', 'Toplu iptal tamamlandı'); }
    async purge(body) { return this._w(() => this.api.purge(body), 'Failed purge', 'Temizlik tamamlandı'); }

    async _w(fn, fb, okMsg) {
        try {
            const r = await fn();
            return {
                success: true,
                data: r?.data ?? r,
                pagination: r?.pagination,
                message: r?.message || okMsg,
            };
        }
        catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || fb, 500, 'UNKNOWN_ERROR', e);
        }
    }
}
